export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8730.3fd0d831.jpg";